export const PROTOCOLS_LOADING_SECTION = "protocols";
